<template>
  <div class="productTypes">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">{{ util.language('商品分类', 'Product Type') }}</el-text>
    </div>
    <el-form :inline="true">
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">{{ util.language('刷新', 'Refresh') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">{{ util.language('新增', 'New') }}</el-button>
          <el-button type="warning" :disabled="show.selected.length != 1" @click="update()">{{ util.language('详情', 'Detail') }}</el-button>
          <el-button type="danger" :disabled="show.selected.length < 1" @click="del()">{{ util.language('删除', 'Delete') }}</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.productTypeList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="ID" width="70" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">{{ scope.row.id }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="enName" :label="util.language('英文名', 'English Name')" show-overflow-tooltip />
      <el-table-column prop="cnName" :label="util.language('中文名', 'Chinese Name')" width="300" show-overflow-tooltip />
      <el-table-column prop="orderBy" :label="util.language('排序', 'Sort')" width="100" />
    </el-table>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'

const router = useRouter()
const tabRef = ref()

const data = reactive({
  productTypeList: [],
})
const loading = reactive({
  find: false,
})
const show = reactive({
  selected: [],
})

const commitFindList = () => {
  loading.find = true
  api.get('/backend/product/getProductType').then(res => {
    data.productTypeList = res.list
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'productType', null)
  router.push('/productType')
}

const del = () => {
  const productTypes = tabRef.value.getSelectionRows()
  const productTypeIdList = productTypes.map(productType => productType.id)
  ElMessageBox.confirm('', {
    title: util.language('确认删除', 'Confirm Delete'),
    message: util.language('将要删除 ' + productTypes.length + ' 个分类。', 'To delete ' + productTypes.length + ' categories.'),
    autofocus: false,
    confirmButtonText: util.language('删除', 'OK'),
    cancelButtonText: util.language('取消', 'Cancel'),
  }).then(() => {
    api.post('/backend/product/delProductType', { ids: productTypeIdList }).then(() => {
      ElMessage.success(util.language('删除成功', 'Success'))
      commitFindList()
    })
  })
}

const update = (row) => {
  const productType = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'productType', productType)
  router.push('/productType')
}

</script>

<style lang="less"></style>